export default {"src":"/_next/static/media/cloud-infrastructure-security.2462adc3.svg","height":401,"width":422,"blurWidth":0,"blurHeight":0};